export interface Location {

  location_id: number;
  subdivision: number;
  subdivision_name: string;
  lot: string;
  street_address: string;
  city: string;
  state: string;
  zip: number;
  plan: number;
  plan_name: string;
  site_notes: string;
  cert_printed: boolean;
  hers_index: number;
  ratingtool: string;
  taxcred: boolean;
  ratingtypeuse: string;
  disclosuresent: boolean;
  hvac_design_id: number;
  permit_no: string;
  registryid: string;
  adminnotes: string;
  pdwdone: boolean;
  emailedbuilder: boolean;
  runnumber: number;
  jurs_id: number;
  taxparcel: string;
  hvac_contractor_id: number;
  customer_id: number;
  hvac_done: boolean;
  hvacnotes: string;
  hvacerrors: boolean;
  builder_done: boolean;
  builder_initials: string;
  tec_date: Date;
  hvacovrd: boolean;
  reviewcomplete: boolean;
  savings: string;
  elevback: string;
  elevfront: string;
  elevright: string;
  elevleft: string;
  closedate: Date;
  adminarchive: boolean;
  sbmt_dsn_id: number;
  hvacresubmt: boolean;
  rebate2: boolean;
  rebate1: boolean;
  rem_done: boolean;
  loclog: string;
  weatherloc: string;
  ekotrope_id: string;
  roughnotice: boolean;
  roughreport: boolean;
  finalnotice: boolean;
  finalreport: boolean;
  missinginfo: boolean;
  scope: string;
  contacts: string;
  permitdate: Date;
  final_done: boolean;
  cfsent: boolean;
  countyform: string;
  billing_notes: string;
  startdate: Date;
  folderid: string;
  gasutility: string;
  elecutility: string;
  premiseno: string;
  premnochkd: boolean;
  prmnochkdat : Date;
  rebate2stat: string;
  auditorname: string;
  constage : string;
  audtype :string;
  audnotes : string;
  ovlscore : number;
  esmfnc : boolean;
  l_tags : number[];
  track: number;
  mfplanoverride: boolean;
  gasrebatedetails: any;
  elecrebatedetails: any;
  swppp : boolean;
  hvac_dr_request : boolean;
}


export interface Locations {
  Error: boolean;
  Message: string;
  Locations?: (LocationsEntity)[] | null;
  Loc?: (LocationsEntity)[] | null;
  Pages: number;
}
export interface LocationsEntity {
  location_id?: number;
  subdivision: string;
  subdivision_name: string;
  lot: string;
  street_address: string;
  city: string;
  state: string;
  zip: string | number;
  plan: string;
  plan_name: string;
  site_notes: string;
  cert_printed: boolean;
  hers_index?: null;
  ratingtool?: null;
  taxcred: boolean;
  ratingtypeuse?: null;
  disclosuresent: boolean;
  hvac_design_id?: string | null;
  permit_no?: string | null;
  registryid?: null;
  adminnotes?: string | null;
  pdwdone: boolean;
  emailedbuilder?: null;
  runnumber: string;
  jurs_id?: null;
  taxparcel: string;
  hvac_contractor_id: string;
  hvac_done?: null;
  hvacnotes?: string | null;
  hvacerrors?: boolean | null;
  builder_done?: boolean | null;
  builder_initials?: string | null;
  tec_date?: string | null;
  hvacovrd?: null;
  reviewcomplete?: null;
  savings?: null;
  elevback?: string | null;
  elevfront?: string | null;
  elevright?: string | null;
  elevleft?: string | null;
  closedate?: string | null;
  adminarchive?: null;
  sbmt_dsn_id?: string | null;
  hvacresubmt?: null;
  rebate2?: null;
  rebate1?: null;
  rem_done?: boolean | null;
  loclog: string;
  weatherloc?: null;
  ekotrope_id?: string | null;
  roughnotice?: null;
  roughreport?: null;
  finalnotice?: null;
  finalreport?: null;
  missinginfo?: null;
  scope?: string | null;
  contacts?: null;
  permitdate?: string | null;
  final_done?: null;
  cfsent?: null;
  countyform?: null;
  billing_notes?: null;
  startdate?: null;
  folderid: string;
  docno?: null;
  region?: null;
  customer_id?: null;
  chklstesign?: null;
  designs?:[];
  hvac_dr_request?: boolean | null;

}

export class LocationModel {
  c?: number;
  subdivision_name?: string;
  lot?: string;
  street_address?: string;
  city?: string;
  state?: string;
  zip?: number;
  location_id?: number
}

export interface locationAdressEntity {
  Error?: boolean;
  Location?: (LocationModel)[] | null;
}


export interface locationCityEntity {
  Error?: boolean;
  city?: (LocationModel)[] | null;
}

export class CityModel {
  city?: string
  city_id?: number
  county?: null
  defaultcz?: null
  elevation?: string
  lister?: string
  region?: string
  state?: string
}

export interface locationPlanEntity {
  Error?: boolean;
  Message?: string;
  Plans?: (PlanModel)[] | null;
}

export class PlanModel {
  customer_name?: string
  drivelink?: null
  plan_family?: null
  plan_id?: number
  plan_name?: string
  plansname?: string
}




